module.exports = __webpack_public_path__ + "static/media/waving26e45cfb7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/categories/waving2.svg
// module id = 1348
// module chunks = 0